import {
  STREAM, GROUP, ASSET,
  COLLECTION, USER, USER_GROUP,
  CONTACT, SHARE, COMPANY
} from './entities';
import LanguageService from '../services/language.service';

import { localizedStrings } from '../../localization';

// french contents has been replaced to english due to initial production release without french.
const frenchContent = localizedStrings._props.en;
const englishContent = localizedStrings._props.en;
const frenchReportsFilters = localizedStrings._props.en.pages.reports.filters;
const englishReportsFilters = localizedStrings._props.en.pages.reports.filters;
const frenchReportsSubFilters = localizedStrings._props.en.pages.reports.filters.entity.sub_filter;
const englishReportsSubFilters = localizedStrings._props.en.pages.reports.filters.entity.sub_filter;

const viewerLanguage = LanguageService.getViewerLanguage();

export const TODAY = 'today';
export const YESTERDAY = 'yesterday';
export const SEVEN_DAYS = '7Days';
export const FOURTEEN_DAYS = '14Days';
export const WEEK_TO_DATE = 'WTD';
export const MONTH_TO_DATE = 'MTD';
export const THIRTY_DAYS = '30Days';
export const NINETY_DAYS = '90Days';
export const CUSTOM = 'custom';

export const DATE_RANGES = [{
  label: TODAY,
  value: viewerLanguage === "fr_ca" ? frenchReportsFilters.date.today : englishReportsFilters.date.today
}, {
  label: YESTERDAY,
  value: viewerLanguage === "fr_ca" ? frenchReportsFilters.date.yesterday : englishReportsFilters.date.yesterday
}, {
  label: SEVEN_DAYS,
  value: `7 ${ viewerLanguage === "fr_ca" ? frenchReportsFilters.date.days : englishReportsFilters.date.days }`
}, {
  label: FOURTEEN_DAYS,
  value: `14 ${ viewerLanguage === "fr_ca" ? frenchReportsFilters.date.days : englishReportsFilters.date.days }`
}, {
  label: WEEK_TO_DATE,
  value: viewerLanguage === "fr_ca" ? frenchReportsFilters.date.week_to_date : englishReportsFilters.date.week_to_date
}, {
  label: MONTH_TO_DATE,
  value: viewerLanguage === "fr_ca" ? frenchReportsFilters.date.month_to_date : englishReportsFilters.date.month_to_date
}, {
  label: THIRTY_DAYS,
  value: `30 ${ viewerLanguage === "fr_ca" ? frenchReportsFilters.date.days : englishReportsFilters.date.days }`
}, {
  label: NINETY_DAYS,
  value: `90 ${ viewerLanguage === "fr_ca" ? frenchReportsFilters.date.days : englishReportsFilters.date.days }`
}];

export const PROPERTIES = [{
  type: STREAM,
  name: viewerLanguage === "fr_ca" ? frenchContent.keywords.stream : englishContent.keywords.stream,
  data_type: STREAM,
  filter_type: 'entity_filter'
},
{
  type: COLLECTION,
  name: viewerLanguage === "fr_ca" ? frenchContent.keywords.collection : englishContent.keywords.collection,
  data_type: COLLECTION,
  filter_type: 'entity_filter'
},
{
  type: ASSET,
  name: viewerLanguage === "fr_ca" ? frenchContent.keywords.asset : englishContent.keywords.asset,
  data_type: ASSET,
  filter_type: 'entity_filter'
},
{
  type: USER,
  name: viewerLanguage === "fr_ca" ? frenchContent.commons.user : englishContent.commons.user,
  data_type: USER,
  filter_type: 'entity_filter'
},
{
  type: USER_GROUP,
  name: viewerLanguage === "fr_ca" ? frenchContent.commons.user_group : englishContent.commons.user_group,
  data_type: USER_GROUP,
  filter_type: 'entity_filter'
},
{
  type: CONTACT,
  name: viewerLanguage === "fr_ca" ? frenchContent.commons.contact : englishContent.commons.contact,
  data_type: CONTACT,
  filter_type: 'entity_filter'
},
{
  type: COMPANY,
  name: viewerLanguage === "fr_ca" ? frenchContent.commons.company : englishContent.commons.company,
  data_type: COMPANY,
  filter_type: 'entity_filter'
}
];


export const CONDITIONS = [{
  type: USER,
  options: [{
    key: 'is',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is : englishReportsSubFilters.is,
    unary: false
  }, {
    key: 'is_not',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_not : englishReportsSubFilters.is_not,
    unary: false
  }, {
    key: 'has_role',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.has_role : englishReportsSubFilters.has_role,
    unary: false 
  }]
}, {
  type: STREAM,
  options: [{
    key: 'is',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is : englishReportsSubFilters.is,
    unary: false
  }, {
    key: 'is_not',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_not : englishReportsSubFilters.is_not,
    unary: false
  }]
}, {
  type: COLLECTION,
  options: [{
    key: 'is',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is : englishReportsSubFilters.is,
    unary: false
  }, {
    key: 'is_not',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_not : englishReportsSubFilters.is_not,
    unary: false
  }]
}, {
  type: ASSET,
  options: [{
    key: 'is',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is : englishReportsSubFilters.is,
    unary: false
  }, {
    key: 'is_not',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_not : englishReportsSubFilters.is_not,
    unary: false
  }]
}, {
  type: SHARE,
  options: [{
    key: 'is',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is : englishReportsSubFilters.is,
    unary: false
  }, {
    key: 'is_not',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_not : englishReportsSubFilters.is_not,
    unary: false
  }]
}, {
  type: USER_GROUP,
  options: [{
    key: 'is',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is : englishReportsSubFilters.is,
    unary: false
  }, {
    key: 'is_not',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_not : englishReportsSubFilters.is_not,
    unary: false
  }]
}, {
  type: CONTACT,
  options: [{
    key: 'is',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is : englishReportsSubFilters.is,
    unary: false
  }, {
    key: 'is_not',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_not : englishReportsSubFilters.is_not,
    unary: false
  }, {
    key: 'is_internal',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_internal : englishReportsSubFilters.is_internal,
    unary: true
  }, {
    key: 'is_not_internal',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_not_internal : englishReportsSubFilters.is_not_internal,
    unary: true
  }]
}, {
  type: COMPANY,
  options: [{
    key: 'is',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is : englishReportsSubFilters.is,
    unary: false
  }, {
    key: 'is_not',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_not : englishReportsSubFilters.is_not,
    unary: false
  }, {
    key: 'is_internal',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_internal : englishReportsSubFilters.is_internal,
    unary: true
  }, {
    key: 'is_not_internal',
    text: viewerLanguage === "fr_ca" ? frenchReportsSubFilters.is_not_internal : englishReportsSubFilters.is_not_internal,
    unary: true
  }]
}
]